
function FormDetails(props) {
  const inputTitle = (props.title !== undefined)? (
    <div className='slp-form-title'>
      {props.title + (props.required? ' *' : '')}
    </div>
   ) : null

   const inputDescription = (props.description !== undefined)? (
    <div className='slp-form-description'>
      {props.description}
    </div>
   ) : null

  const inputDetails = (props.title !== undefined || props.description !== undefined)? (
    <div className={'slp-form-details' + (props.narrow? '-narrow' : '')}>
      {inputTitle}
      {inputDescription}
    </div>
   ) : null;

  return inputDetails;
}

export default FormDetails;